import useHostedVideoManifestFetchOnHover from './useHostedVideoManifestFetchOnHover';
import useSavedVideoPreview from './useSavedVideoPreview';

const useHostedVideoSmallestPreview = (hostId?: string) => {
  const [hoverRef, isHovered] = useHostedVideoManifestFetchOnHover(hostId);
  const videoPreview = useSavedVideoPreview(hostId);

  return [hoverRef, videoPreview, isHovered] as const;
};

export default useHostedVideoSmallestPreview;
